module.exports = __webpack_public_path__ + "media/pick-image.aa144118.webm";